import { SelectOptions } from '@/components/input'

export const eliminationOptions: SelectOptions = [
  { key: 'ROUND_ROBIN', value: 'ROUND_ROBIN', label: 'RoundRobin' },
  { key: 'COMPASS', value: 'COMPASS', label: 'Waterfall' },
  { key: 'FLEX', value: 'FLEX', label: 'FlexLeague' },
]

export const bracketFormatOptions: SelectOptions = [
  { key: 'DOUBLES', value: 'DOUBLES', label: 'Doubles' },
  { key: 'SINGLES', value: 'SINGLES', label: 'Singles' },
]

export const playerGroupOptions: SelectOptions = [
  { key: 'MIXED', value: 'MIXED', label: 'Mixed' },
  { key: 'OPEN', value: 'OPEN', label: 'Open' },
  { key: 'MEN', value: 'MEN', label: 'Men' },
  { key: 'WOMEN', value: 'WOMEN', label: 'Women' },
]

export const matchStructureOptions = [
  { key: '1 Game to 11 - Win by 1', value: '1 Game to 11 - Win by 1' },
  { key: '1 Game to 11 - Win by 2', value: '1 Game to 11 - Win by 2' },
  { key: '1 Game to 15 - Win by 1', value: '1 Game to 15 - Win by 1' },
  { key: '1 Game to 15 - Win by 1', value: '1 Game to 15 - Win by 1' },
  { key: 'Best 2 of 3 Games to 11 - Win by 1', value: 'Best 2 of 3 Games to 11 - Win by 1' },
  { key: 'Best 2 of 3 Games to 11 - Win by 2', value: 'Best 2 of 3 Games to 11 - Win by 2' },
  { key: 'Best 3 of 5 Games to 11 - Win by 1', value: 'Best 3 of 5 Games to 11 - Win by 1' },
  { key: 'Best 3 of 5 Games to 11 - Win by 1', value: 'Best 3 of 5 Games to 11 - Win by 1' },
]

export const skillLevelOptions = [
  { value: 2, label: '2.0' },
  { value: 3, label: '3.0' },
  { value: 4, label: '4.0' },
  { value: 5, label: '5.0' },
  { value: 6, label: '6.0' },
  { value: 7, label: '7.0' },
  { value: 8, label: '8.0' },
]

export const distanceOptions = [
  { value: 25, label: '25mi' },
  { value: 50, label: '50mi' },
  { value: 75, label: '75mi' },
  { value: 100, label: '100mi' },
  { value: 0, label: 'No Limit' },
]

export const leagueFilterOptions = [
  { key: 'View All', value: 'ACTIVE' },
  { key: 'Upcoming', value: 'UPCOMING' },
  { key: 'Past', value: 'COMPLETE' },
]

export const ratingsOptions = [
  { key: 'All', value: 'ALL' },
  { key: 'DUPR', value: 'DUPR' },
  { key: 'Provisional', value: 'PROVISIONAL' },
]

export const numberOfGamesOptions = [
  { key: '1', value: 1 },
  { key: '2', value: 2 },
  { key: '3', value: 3 },
  { key: '4', value: 4 },
  { key: '5', value: 5 },
  { key: '6', value: 6 },
]

export const matchTypeOptions = [
  { key: 'singles', label: 'Singles', value: 'SINGLES' },
  { key: 'doubles', label: 'Doubles', value: 'DOUBLES' },
  { key: 'any', label: 'Any', value: null },
]

export const matchDateOptions = [
  { key: 'matchDate', label: 'MatchDate', value: 'MATCH_DATE' },
  { key: 'createdDate', label: 'CreatedDate', value: 'CREATED_DATE' },
  { key: 'modifiedDate', label: 'ModifiedDate', value: 'MODIFIED_DATE' },
]

export const clubRankingsOptions = [
  { key: 'doubles', label: 'Doubles', value: 'doubles' },
  { key: 'singles', label: 'Singles', value: 'singles' },
]
